<template>
  <div class="vp-checkbox">
    <Checkbox
      v-bind="{ ...$attrs, ...$props }"
      @update:model-value="onChange"
    >
      <template #default="{ checked, toggle }">
        <div
          class="vnf-input-box flex justify-items-center gap-2"
          :class="{ checked }"
          @click="toggle"
        >
          <div class="vnf-checkbox-icon">
            <CheckboxMarked
              v-if="checked"
              class="checkbox-icon"
            />
            <CheckboxBlankOutline
              v-else
              class="checkbox-icon"
            />
          </div>
          <label
            v-if="label"
            class="vp-label mt-1"
          >
            {{ label }}
          </label>
        </div>
      </template>
    </Checkbox>
  </div>
</template>

<script setup lang="ts">
import { Checkbox } from 'vuniform';
import { CheckboxBlankOutline, CheckboxMarked } from 'mdue';
// This element needs to be reworked completely in the future

const emit = defineEmits<{
  (e: 'change', value?: unknown): void;
}>();

interface Props {
  inputId: string;
  disabled?: boolean;
  label?: string;
  errors?: string[];
  trueValue?: unknown;
  falseValue?: unknown;
}

defineProps<Props>();

const onChange = (e: unknown, cb: (value?: unknown) => void) => {
  if (cb) {
    cb(e);
  }
  emit('change', e);
};
</script>
